import { render, staticRenderFns } from "./UserTableMenu.vue?vue&type=template&id=182497b6&scoped=true&"
import script from "./UserTableMenu.vue?vue&type=script&lang=js&"
export * from "./UserTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182497b6",
  null
  
)

export default component.exports